export default "__VITE_ASSET__DQWUTEzV__"